import React, { useEffect } from 'react';
import { GlobalLoader } from '@klp/design/Loader';

export const App = ({ children }: { children?: React.ReactNode }) => {
    useEffect(() => {
        try {
            if (window.frameElement && window.top) {
                window.top.location.replace(window.location.href);
                return;
            }
        } catch (e) {
            console.error('Redirection error:', e);
        }
    }, []);

    return (
        <>
            {children}
            <GlobalLoader />
        </>
    );
};
